<template>
  <nav aria-label="Page navigation">
    <ul class="pagination">
      <li @click="changePage(1)">
        <a href="#" aria-label="Previous" :style="{ 'color': '#' + $store.state.color }">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li v-for="(item, index) in Math.ceil(count/pageSize)" @click="changePage(index + 1)"
        :class="{'disabled': page === index+1}" v-if="(page < index + 5) && (page > index - 5)">
         <a href="#" :style="{ 'color': page !== index+1 ? $store.state.color : ''}">{{index + 1}}</a>
       </li>
      <li @click="changePage(Math.ceil(count/pageSize))">
        <a href="#" aria-label="Next" :style="{ 'color': $store.state.color }">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['page', 'pageSize', 'count'],
  methods: {
    changePage (page) {
      this.$emit('change-page', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue